export const REQUEST_CANCEL_ORDER = 'REQUEST_CANCEL_ORDER';
export const REQUEST_CANCEL_ORDER_FAILURE = 'REQUEST_CANCEL_ORDER_FAILURE';
export const REQUEST_CANCEL_ORDER_SUCCESS = 'REQUEST_CANCEL_ORDER_SUCCESS';
export const ECOMMERCE_ORDER_CLEARED = 'ECOMMERCE_ORDER_CLEARED';

export const SHOW_FAILED_UPDATE_OFFER_MODAL = 'SHOW_FAILED_UPDATE_OFFER_MODAL';
export const HIDE_FAILED_UPDATE_OFFER_MODAL = 'HIDE_FAILED_UPDATE_OFFER_MODAL';

export type FailedOfferUpdateState = {
    showFailedUpdateOfferModal: boolean;
};
